import React from "react";

import { Container, Row, Col } from "reactstrap";

function UkCbdcHeader() {
  return (
    <div className="header">
      <Container>
        <Row>
          <Col className="mx-auto my-5 text-center" lg="10">
            <h1 className="display-2 text-default">
              The Future of CBDCs and the Intersection of CeFi and DeFi
            </h1>
          </Col>
        </Row>
        <Row>
          <div className="floating-box rounded mx-3 bg-default">
            <h2 className="lead text-white p-5">
              The shift away from traditional physical cash and coin payments in the UK has accelerated in 
              recent years, with less than<a href="https://brc.org.uk/news/corporate-affairs/card-use-soars-to-90-of-retail-spending/" 
              target="_blank" rel="noreferrer" className=" text-info"> 15% of transactions</a> being conducted using cash.
            </h2>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default UkCbdcHeader;
